import { createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
import { getToken } from "helpers/Tokens";

const initialState = {
  notificationList: [],
  loading:false
};

export const getNotificationDetails = createAsyncThunk(
  "getNotificationDetails/setNotificationDetails",
  async (_, thunkAPI) => {
    try {
      let userData= getToken();
      const response = await ApiClient.get(`notification?userId=${userData?.id}`);    
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const notificationDetailsSlice = createSlice({
  name: "getNotificationDetails",
  initialState,
  reducers: {
    setNotificationDetails(state, action) {
      state.notificationList = action.payload;
    },
  },
  extraReducers: {
    [getNotificationDetails.pending]: (state) => {
      state.loading = true
    },
    [getNotificationDetails.fulfilled]: (state, action) => {
      state.loading = false     
      state.notificationList = action.payload;
    },
    [getNotificationDetails.rejected]: (state) => {
      state.loading = false
    },
  },
});

export const { setNotificationDetails } = notificationDetailsSlice.actions;
export default notificationDetailsSlice;
